import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import commonReducers from "../reducers"

export const thunk = createAsyncThunk("common/allUsers", async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get("/all_users/")
    const allUsers = response.data.map((userData) => ({
      id: userData.id,
      username: userData.username,
      rankingPoints: userData.ranking_points,
      // The hall of fame draws each player's look in the frame of their league (owner, 2026-10-08).
      league: userData.league ?? null,
      equippedCosmetics: userData.equipped_cosmetics,
    }))
    return { allUsers }
  } catch (error) {
    return rejectWithValue(error.response.data)
  }
})

export const onSucceed = commonReducers.setData

const thunkObject = { thunk, onSucceed }
export default thunkObject
